import Components from '../../Components';
import { receptionRoleAccess } from '../../Core/Utils/userPermissions';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/home/reception/checkinactivity',
  exact: true,
  name: 'navigation.menu.checkin',
  private: true,
  type: containerTypes.PAGE,
  requiresMemberPortalAccess: true,
  isAuthorized: ({ profile }) => {
    return receptionRoleAccess.accessReception({ profile });
  },
};

export default RouteConfig;
